<template>
  <div>
    <!-- Form -->
    
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Item Name *"
                      v-model="formSchema.item_name"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Asset Category *"
                      item-text="cat_name"
                      item-value="id"
                      v-model="formSchema.cat_id"
                      :items="assetCats"
                      :rules="[v => !!v || 'Field is required']"
                      @change="getSubCategory"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Asset Sub Category *"
                      item-text="sub_cat_name"
                      item-value="id"
                      v-model="formSchema.sub_cat_id"
                      :items="assetSubCats"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-autocomplete
                      label="Measurement Unit *"
                      item-text="name"
                      item-value="id"
                      v-model="formSchema.unit_id"
                      :items="assetUnits"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-6">
                      <v-radio-group v-model="formSchema.is_fixed_asset" row>
                        <v-radio label="Fixed Asset" :value="1"></v-radio>
                        <v-radio label="Current Asset" :value="0"></v-radio>
                      </v-radio-group>
                  </v-flex>
                  <v-flex xs12 md2 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
              <v-btn class="info" flat @click.native="close({message:'Form Reseted',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema", "assetSubCats"],
  // props: { formSchema: formSchema, assetSubCats: assetSubCats },

  // Component Data Declaration Functions -------------------------------------------------------
  data: () => ({
    valid: true,
    isActiveVal: 1,
    assetCats: [],
    //assetSubCats: [],
    assetUnits: [],

    rules: {
      decimalOnly: value => {
        const pattern = /^\d+(\.\d)?\d*$/;
        return pattern.test(value) || "Not a valied number";
      }
    }
  }),

  // Component Computed Functions -------------------------------------------------------
  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Item"
        : "Add Asset Item";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  // Component Created Functions -------------------------------------------------------
  created() {
    var root = this;
    // Get Categorylis
    commonService.getAllData("get_asset_cat_info").then(res => {
      root.assetCats = res.data;
    });

    // Asset Unit List
    commonService.getAllData("get_unit").then(res => {
      root.assetUnits = res.data;
    });
  },

  // Component Methods -------------------------------------------------------
  methods: {
    validateBeforeSubmit(e) {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      formSchema.purchase_date = root.changeFormateYMD(
        this.formSchema.purchase_date
      );

      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_item")
            .then(res => {
              if (res.status == 1) {
                res.action = "edit";
                this.close(res);
              }
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "asset_item")
            .then(res => {
              if (res.status == 1) {
                res.action = "add";
                this.close(res);
              }
            });
        }
      }
    },

    // Get Sub Categories by Category Id
    getSubCategory() {
      var cat_id = this.formSchema.cat_id;
      commonService
        .getAllDataById(cat_id, "get_asset_sub_cat_info_by_id")
        .then(res => {
          this.assetSubCats = res.data;
        });
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/asset/asset_item/asset_item_form.vue